import { initialize, openSession, changeUser, subscribeToInAppMessage, showInAppMessage } from '@braze/web-sdk';

const configureBraze = async () => {
  const data = global.__AT_DATA__;

  if (!data || !data.BRAZE_KEY) {
    return;
  }

  initialize(data.BRAZE_KEY, {
    baseUrl: 'https://sdk.iad-03.braze.com',
    allowUserSuppliedJavascript: true
  });

  if (data.store.user) {
    changeUser(String(data.store.user.id));
  }

  /* 
    Exclude these paths from showing in-app messages:
    - /plans/* and /plus/*
    - /25hikes
    - /nbc-the-americas
    - /2025-summer
  */
  subscribeToInAppMessage(inAppMessage => {
    const excludedIamPath = /\/(plans|plus|25hikes|nbc-the-americas|2025-summer)/.test(data.pathname);
    if (!excludedIamPath) {
      showInAppMessage(inAppMessage);
    }
  });

  openSession();
};

export default configureBraze;
